import React from "react";
import Skeleton from "@material-ui/lab/Skeleton";
import { Typography } from "@material-ui/core";

const SkeletonLoader = ({ lines }) => {
  return (
    <>
      {lines >= 1 && (
        <Typography variant="caption">
          <Skeleton />
        </Typography>
      )}
      {lines >= 2 && (
        <Typography variant="body1">
          <Skeleton />
        </Typography>
      )}
      {lines >= 3 && (
        <Typography variant="h3">
          <Skeleton />
        </Typography>
      )}
      {lines >= 4 && (
        <Typography variant="h1">
          <Skeleton />
        </Typography>
      )}
    </>
  );
};

export default SkeletonLoader;
